export const forceReflow = (node: HTMLElement): number => node.scrollTop
